<!-- 
AllCategoryIndex.vue
功能：所有名單頁
作者：i9400538 陳博承
完成：2021-11-23
-->
<template>
  <main :class="isBox?'boxPadding':''">
    <div class="tab-content" :class="{'section-loading': listAreaLoading}">
      <!-- 潛力新客 -->
      <high-potential-new-customer
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_HIGH_POTENTIAL_NEW_CUSTOMER'"
      />

      <!-- 新滿意足 -->
      <more-benefits
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_MORE_BENEFITS'"
      />

      <!-- 守護樂齡 -->
      <medical-care
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_MEDICAL_CARE'"
      />

      <!-- 呵護公教 -->
      <one-love :status="status" @change-status="changeStatus" v-if="status === 'STATUS_ONE_LOVE'" />

      <!-- 實支實付目標客戶 -->
      <real-paying-target
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_REAL_PAYING_TARGET'"
      />

      <!-- 公教長照 -->
      <long-term-care
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_LONG_TERM_CARE'"
      />

      <!-- 身心障礙 -->
      <physical-mental-disorder
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_PHYSICAL_MENTAL_DISORDER'"
      />

      <!-- 小額終老 -->
      <small-amount-old-age
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_SMALL_AMOUNT_OLD_AGE'"
      />

      <!-- 樂安心保 -->
      <happy-mind-insurance
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_HAPPY_MIND_INSURANCE'"
      />

      <real-paid
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_REAL_PAID'"
      />

      <!--ONLY U-->
      <i-only-u :status="status" @change-status="changeStatus" v-if="status === 'STATUS_I_ONLY_U'" />

      <!--三倍醫靠-->
      <triple-care
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_TRIPLE_CARE'"
      />

      <!--優利保障-->
      <profit-guarantee
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_PROFIT_GUARANTEE'"
      />

      <!--真心守護-->
      <sincere-guard
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_SINCERE_GUARD'"
      />

      <!--醫療有約-->
      <medical-EDM
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_MEDICAL_EDM'"
      />

      <!-- 異動後實質接觸明細 -->
      <substantial-contact-details
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_SUBSTANTIAL_CONTACT_DETAILS'"
      />

      <!--停效保單-->
      <stop-effect
        :status="status"
        @change-status="changeStatus"
        v-if="status ==='STATUS_STOP_EFFECT'"
      />

      <!-- 辦理集彙集提醒 -->
      <handle-group-remittance-notification
        :status="status"
        @change-status="changeStatus"
        v-if="status ==='STATUS_HANDLE_GROUP_REMITTANCE_NOTIFICATION'"
      />

      <!-- 尊榮服務 -->
      <honor-service
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_HONOR_SERVICE'"
      />

      <!-- 推動名單 -->
      <push-list
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_PUSH_LIST'"
      />

      <!-- 迎賓禮 -->
      <welcome-ceremony
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_WELCOME_CEREMONY'"
      />

      <!-- 國泰一家人 -->
      <cathay-family
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_CATHAY_FAMILY'"
      />

      <!-- 健康禮 -->
      <health-ceremony
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_HEALTH_CEREMONY'"
      />

      <!-- 免費健檢 -->
      <free-health-check
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_FREEHEALTH_CHECK'"
      />

      <!-- 線上諮詢 -->
      <online-consultation
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_ONLINE_CONSULTATION'"
      />

      <!-- 即將停效 -->
      <will-stop-effect
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_WILL_STOP_EFFECT'"
      />

      <stop-effect-after
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_STOP_EFFECT_AFTER_HALF_YEAR'"
      />

      <!-- 保單給付應領未領 -->
      <warranty-should-receive-not-receive
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_WARRANTY_SHOULD_RECEIVE_NOT_RECEIVE'"
      />

      <!-- 滿期年金未辦 -->
      <full-annuity-not-handle
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_FULL_ANNUITY_NOT_HANDLE'"
      />

      <!-- 未兌現支票 -->
      <unpaid-check
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_UNPAID_CHECK'"
      />

      <!-- 未訪件明細 -->
      <remote-document-warning
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_REMOTE_DOCUMENT_WARNING'"
      />

      <!-- 滿期目標客戶 -->
      <Full-Target-Custom
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_FULL_TARGET_CUSTOM'"
      />

      <!-- 年金目標客戶 -->
      <Annuity-Target-Custom
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_ANNUITY_TARGET_CUSTOM'"
      />

      <!--易Call保待重簽名單-->
      <Ecall-Service-Item
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_ECALL_SERVICE_ITEM'"
      />

      <stop-effect-query
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_STOP_EFFECT_QUERY'"
      />

      <!--心安逸名單-->
      <mind-with-joy
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_MIND_WITH_JOY'"
      />

      <!--未申辦「FitBack健康吧」-->
      <not-apply-for-c-w-p
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_NOT_APPLY_FOR_CWP'"
      />

      <!--傷害險調整提高保額-->
      <injury-insurance-adjustment
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_INJURY_INSURANCE_ADJUSTMENT'"
      />

      <!--網路服務推動名單-->
      <web-service-push-list
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_WEB_SERVICE_PUSH_LIST'"
      />

      <!--客戶資料校正專案-->
      <Info-adjustment
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_INFO_ADJUSTMENT'"
      />

      <!--停效關懷專案-->
      <suspension-care
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_SUSPENSION_CARE'"
      />

      <!--準未訪件明細-->
      <the-remote-document-warning
        :status="status"
        @change-status="changeStatus"
        v-if="status === 'STATUS_THE_REMOTE_DOCUMENT_WARNING'"
      />

      <!-- 外幣匯款手續費優惠 -->
      <foreign-currency-handle-discount
        v-if="status === 'STATUS_FOREIGN_CURRENCY_HANDLE_DISCOUNT'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 證券數位服務 -->
      <securities-digital-service
        v-if="status === 'STATUS_SECURITIES_DIGITAL_SERVICE'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 高資產復委託 -->
      <high-assets-redelegation
        v-if="status === 'STATUS_HIGH_ASSETS_REDELEGATION'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 車/火險預約單 -->
      <car-fire-insurance-reserve
        v-if="status === 'STATUS_CAR_FIRE_INSURANCE_RESERVE'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 車險未續保名單 -->
      <car-insurance-un-renewed
        v-if="status === 'STATUS_CAR_INSURANCE_UNRENEWED'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 國泰伴你健康 -->
      <cathay-with-your-health
        v-if="status === 'STATUS_CATHAY_WITH_YOUR_HEALTH'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 企業客戶申辦官網會員名單 -->
      <customer-apply-for-member
        v-if="status === 'STATUS_CUSTOMER_APPLY_FOR_MEMBER'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 泰好客 -->
      <tai-hospitable
        v-if="status === 'STATUS_TAI_HOSPITABLE'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 美元保障 -->
      <dollar-guarantee
        v-if="status === 'STATUS_DOLLAR_GUARANTEE'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 高階白領企業福利家 -->
      <high-class-white-collar
        v-if="status === 'STATUS_HIGH_CLASS_WHITE_COLLAR'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 團險Keyman -->
      <group-insurance-key-man
        v-if="status === 'STATUS_GROUP_INSURANCE_KEY_MAN'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 身故關懷名單a -->
      <die-care v-if="status === 'STATUS_DIE_CARE'" :status="status" @change-status="changeStatus" />

      <!-- 未滿15足歲保障缺口 -->
      <under-15-list
        v-if="status === 'STATUS_UNDER_15_LIST'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 外溢證明文件未上傳 -->
      <spillover-policy
        v-if="status === 'STATUS_SPILLOVER_POLICY'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 信用卡身分驗證異常名單 -->
      <credit-card-validation
        v-if="status === 'STATUS_CREDIT_CARD_VALIDATION'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 房貸精準行銷名單 -->
      <home-loan-list
        v-if="status === 'STATUS_HOME_LOAN_LIST'"
        :status="status"
        @change-status="changeStatus"
      />

       <!-- 事件偵測-人資神助攻 -->
       <event-detection-h-r
        v-if="status === 'STATUS_EVENT_DETECTION_HR'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- FitBack愛好者 -->
      <fitback-lover
        v-if="status === 'STATUS_FITBACK_LOVER'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 收費轉型關懷名單 -->
      <premium-transformation
        v-if="status === 'STATUS_PREMIUM_TRANSFORMATION'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 事件偵測名單 -->
      <event-detection
        v-if="status === 'STATUS_EVENT_DETECTION'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 事件偵測 高保險意識 -->
      <event-detection-high-coverage
        v-if="status === 'STATUS_EVENT_DETECTION_HIGHCOVERAGE'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 服務/權益 約定扣款獎勵活動 -->
      <agreed-deduction
        v-if="status === 'STATUS_AGREED_DEDUCTION'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 客戶盡職調查問卷 -->
      <customer-survey
        v-if="status === 'STATUS_CUSTOMER_SURVEY'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 高資產客 -->
      <high-net-worth
        v-if="status === 'STATUS_HIGH_NET_WORTH'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 潛力高資產客 -->
      <potential-high-net-worth
        v-if="status === 'STATUS_POTENTIAL_HIGH_NET_WORTH'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- 專屬健康服務 -->
      <customer-list-079
        v-if="status === 'STATUS_CUSTOMER_LIST_079'"
        :status="status"
        @change-status="changeStatus"
      />

      <!-- (試點)高潛力名單-->
      <customer-list-080
        v-if="status === 'STATUS_CUSTOMER_LIST_080'"
        :status="status"
        @change-status="changeStatus"
      />
    </div>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
//component
import EventDetection from "@/desktop/components/ListsArea/PrecisionMarketing/EventDetection";
import EventDetectionHighCoverage from "@/desktop/components/ListsArea/PrecisionMarketing/EventDetectionHighCoverage";
import TaiHospitable from "@/desktop/components/ListsArea/PrecisionMarketing/TaiHospitable";
import DollarGuarantee from "@/desktop/components/ListsArea/PrecisionMarketing/DollarGuarantee";
import HighPotentialNewCustomer from "@/desktop/components/ListsArea/PrecisionMarketing/HighPotentialNewCustomer";
import MoreBenefits from "@/desktop/components/ListsArea/PrecisionMarketing/MoreBenefits";
import MedicalCare from "@/desktop/components/ListsArea/PrecisionMarketing/MedicalCare";
import OneLove from "@/desktop/components/ListsArea/PrecisionMarketing/OneLove";
import RealPayingTarget from "@/desktop/components/ListsArea/PrecisionMarketing/RealPayingTarget";
import LongTermCare from "@/desktop/components/ListsArea/PrecisionMarketing/LongTermCare";
import PhysicalMentalDisorder from "@/desktop/components/ListsArea/PrecisionMarketing/PhysicalMentalDisorder";
import SmallAmountOldAge from "@/desktop/components/ListsArea/PrecisionMarketing/SmallAmountOldAge";
import HappyMindInsurance from "@/desktop/components/ListsArea/PrecisionMarketing/HappyMindInsurance";
import IOnlyU from "@/desktop/components/ListsArea/PrecisionMarketing/iOnlyU";
import TripleCare from "@/desktop/components/ListsArea/PrecisionMarketing/TripleCare";
import ProfitGuarantee from "@/desktop/components/ListsArea/PrecisionMarketing/ProfitGuarantee";
import SincereGuard from "@/desktop/components/ListsArea/PrecisionMarketing/SincereGuard";
import MedicalEDM from "@/desktop/components/ListsArea/PrecisionMarketing/MedicalEDM";
import Under15List from "@/desktop/components/ListsArea/PrecisionMarketing/Under15List";
import HighNetWorth from "@/desktop/components/ListsArea/PrecisionMarketing/HighNetWorth";
import PotentialHighNetWorth from "@/desktop/components/ListsArea/PrecisionMarketing/PotentialHighNetWorth";
import CustomerList079 from "@/desktop/components/ListsArea/PrecisionMarketing/CustomerList079";
import CustomerList080 from "@/desktop/components/ListsArea/PrecisionMarketing/CustomerList080";

import AgreedDeduction from "@/desktop/components/ListsArea/ServiceRight/AgreedDeduction";
import SubstantialContactDetails from "@/desktop/components/ListsArea/ServiceRight/SubstantialContactDetails";
import HonorService from "@/desktop/components/ListsArea/ServiceRight/HonorService";
import PushList from "@/desktop/components/ListsArea/ServiceRight/PushList";
import WelcomeCeremony from "@/desktop/components/ListsArea/ServiceRight/WelcomeCeremony";
import CathayFamily from "@/desktop/components/ListsArea/ServiceRight/CathayFamily";
import HealthCeremony from "@/desktop/components/ListsArea/ServiceRight/HealthCeremony";
import HandleGroupRemittanceNotification from "@/desktop/components/ListsArea/ServiceRight/HandleGroupRemittanceNotification";
import StopEffect from "@/desktop/components/ListsArea/ServiceRight/StopEffect";
import FreeHealthCheck from "@/desktop/components/ListsArea/ServiceRight/FreeHealthCheck";
import OnlineConsultation from "@/desktop/components/ListsArea/ServiceRight/OnlineConsultation";
import WillStopEffect from "@/desktop/components/ListsArea/ServiceRight/WillStopEffect";
import StopEffectAfter from "@/desktop/components/ListsArea/ServiceRight/StopEffectAfter";
import WarrantyShouldReceiveNotReceive from "@/desktop/components/ListsArea/ServiceRight/WarrantyShouldReceiveNotReceive";
import FullAnnuityNotHandle from "@/desktop/components/ListsArea/ServiceRight/FullAnnuityNotHandle";
import UnpaidCheck from "@/desktop/components/ListsArea/ServiceRight/UnpaidCheck";
import RemoteDocumentWarning from "@/desktop/components/ListsArea/ServiceRight/RemoteDocumentWarning";
import FullTargetCustom from "@/desktop/components/ListsArea/ServiceRight/FullTargetCustom";
import AnnuityTargetCustom from "@/desktop/components/ListsArea/ServiceRight/AnnuityTargetCustom";
import EcallServiceItem from "@/desktop/components/ListsArea/ServiceRight/EcallServiceItem";
import StopEffectQuery from "@/desktop/components/ListsArea/ServiceRight/StopEffectQuery";
import MindWithJoy from "@/desktop/components/ListsArea/ServiceRight/MindWithJoy";
import NotApplyForCWP from "@/desktop/components/ListsArea/ServiceRight/NotApplyForCWP";
import InjuryInsuranceAdjustment from "@/desktop/components/ListsArea/ServiceRight/InjuryInsuranceAdjustment";
import WebServicePushList from "@/desktop/components/ListsArea/ServiceRight/WebServicePushList";
import InfoAdjustment from "@/desktop/components/ListsArea/ServiceRight/InfoAdjustment";
import SuspensionCare from "@/desktop/components/ListsArea/ServiceRight/SuspensionCare";
import TheRemoteDocumentWarning from "@/desktop/components/ListsArea/ServiceRight/TheRemoteDocumentWarning";
import DieCare from "@/desktop/components/ListsArea/ServiceRight/DieCare";
import SpilloverPolicy from "@/desktop/components/ListsArea/ServiceRight/SpilloverPolicy";
import CreditCardValidation from "@/desktop/components/ListsArea/ServiceRight/CreditCardValidation";
import CustomerSurvey from "@/desktop/components/ListsArea/ServiceRight/CustomerSurvey";

import ForeignCurrencyHandleDiscount from "@/desktop/components/ListsArea/IntegratedMarketing/ForeignCurrencyHandleDiscount";
import SecuritiesDigitalService from "@/desktop/components/ListsArea/IntegratedMarketing/SecuritiesDigitalService";
import HighAssetsRedelegation from "@/desktop/components/ListsArea/IntegratedMarketing/HighAssetsRedelegation";
import CarFireInsuranceReserve from "@/desktop/components/ListsArea/IntegratedMarketing/CarFireInsuranceReserve";
import CarInsuranceUnRenewed from "@/desktop/components/ListsArea/IntegratedMarketing/CarInsuranceUnRenewed";

import CathayWithYourHealth from "@/desktop/components/ListsArea/GroupRelated/CathayWithYourHealth";
import CustomerApplyForMember from "@/desktop/components/ListsArea/GroupRelated/CustomerApplyForMember";
import HighClassWhiteCollar from "@/desktop/components/ListsArea/GroupRelated/HighClassWhiteCollar";
import GroupInsuranceKeyMan from "@/desktop/components/ListsArea/GroupRelated/GroupInsuranceKeyMan";
import HomeLoanList from "@/desktop/components/ListsArea/GroupRelated/HomeLoanList";
import EventDetectionHR from "@/desktop/components/ListsArea/GroupRelated/EventDetectionHR";
import FitbackLover from "@/desktop/components/ListsArea/GroupRelated/FitbackLover";

import PremiumTransformation from "@/desktop/components/ListsArea/DecreeZone/PremiumTransformation";


export default {
  name: "AllCategoryIndex",
  mixins: [commonMixin],
  components: {
    EventDetection,
    EventDetectionHighCoverage,
    TaiHospitable,
    DollarGuarantee,
    HighPotentialNewCustomer,
    MoreBenefits,
    MedicalCare,
    OneLove,
    RealPayingTarget,
    LongTermCare,
    PhysicalMentalDisorder,
    SmallAmountOldAge,
    HappyMindInsurance,
    IOnlyU,
    TripleCare,
    ProfitGuarantee,
    SincereGuard,
    MedicalEDM,
    AgreedDeduction,
    SubstantialContactDetails,
    HonorService,
    PushList,
    WelcomeCeremony,
    CathayFamily,
    HealthCeremony,
    FreeHealthCheck,
    OnlineConsultation,
    WillStopEffect,
    StopEffectAfter,
    StopEffect,
    StopEffectQuery,
    HandleGroupRemittanceNotification,
    WarrantyShouldReceiveNotReceive,
    FullAnnuityNotHandle,
    UnpaidCheck,
    RemoteDocumentWarning,
    FullTargetCustom,
    AnnuityTargetCustom,
    EcallServiceItem,
    MindWithJoy,
    NotApplyForCWP,
    InjuryInsuranceAdjustment,
    WebServicePushList,
    InfoAdjustment,
    SuspensionCare,
    TheRemoteDocumentWarning,
    ForeignCurrencyHandleDiscount,
    SecuritiesDigitalService,
    HighAssetsRedelegation,
    CarFireInsuranceReserve,
    CarInsuranceUnRenewed,
    CathayWithYourHealth,
    CustomerApplyForMember,
    HighClassWhiteCollar,
    GroupInsuranceKeyMan,
    DieCare,
    Under15List,
    SpilloverPolicy,
    CreditCardValidation,
    HomeLoanList,
    PremiumTransformation,
    EventDetectionHR,
    FitbackLover,
    CustomerSurvey,
    HighNetWorth,
    PotentialHighNetWorth,
    CustomerList079,
    CustomerList080

  },
  props: {
    status: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    isBox() {
      return this.UserInfo.userType === "box";
    }
  },
  data() {
    //data block layout
    return {
      data: {},
      listAreaLoading: false,
      currentTab: 1
    };
  },
  methods: {
    changeStatus() {
      this.$emit("go-default");
    }
  }
};
</script>
<style scoped>
.boxPadding {
  padding-top: 0px !important;
}
</style>